import { BButton, BCard,BFormGroup,BFormFile } from "bootstrap-vue";

export default {
  components: {
    BButton,
    BCard,BFormGroup,BFormFile
  },
  props: {
    files: Array,
  },
  data() {
    return {
      realValue: this.files,
      deletedFilesId: [],
      newFiles: [],
    };
  },
  watch: {
    files: function(newVal) {
      this.realValue = newVal;
    }, 
    deletedFilesId: function(newVal) {
      this.$emit("deleted-iles-id", newVal);
    },
    newFiles: function(newVal) {
      this.$emit("new-files", newVal);
    },
  },
  methods: {
    deleteFilesItem(id) {
      if (id) {
        this.realValue = this.realValue.filter((file) => file.id != id);
        this.deletedFilesId.push(id);
      }
    },
   
  },
};
